import { useEffect } from 'react';

import { useSharedState } from '@trello/shared-state';
import { workspaceNavigationHiddenState } from './workspaceNavigationHiddenState';
import { workspaceNavigationErrorState } from './workspaceNavigationErrorState';
import { RouteId, useRouteId } from '@trello/routes';
import { isEmbeddedDocument } from '@trello/browser';
import { useWorkspace } from '@trello/workspaces';
import { usePreviousWhileLoading } from './usePreviousWhileLoading';
import { memberId } from '@trello/session-cookie';

export const navHiddenRoutes = [
  RouteId.MEMBER_HOME_BOARDS,
  RouteId.TEAM_HIGHLIGHTS,
  RouteId.TEAM_REPORTS,
  RouteId.TEAM_GETTING_STARTED,
  RouteId.CREATE_FIRST_BOARD,
  RouteId.CREATE_FIRST_TEAM,
];

export function useWorkspaceNavigationHiddenStateUpdater() {
  const [navHiddenState, setNavHiddenState] = useSharedState(
    workspaceNavigationHiddenState,
  );
  const [navErrorState] = useSharedState(workspaceNavigationErrorState);
  const routeId = useRouteId();
  const workspace = useWorkspace();

  const isGlobal = usePreviousWhileLoading(
    workspace.isGlobal,
    workspace.isLoading,
    false,
  );

  const hideWorkspaceNav =
    isEmbeddedDocument() ||
    navHiddenRoutes.includes(routeId) ||
    isGlobal ||
    navErrorState.hasError ||
    !memberId;

  useEffect(() => {
    if (hideWorkspaceNav !== navHiddenState.hidden) {
      setNavHiddenState({ hidden: hideWorkspaceNav });
    }
  }, [hideWorkspaceNav, navHiddenState.hidden, setNavHiddenState]);
}
